import { useEffect } from "react";

/**
 * Adds <meta name="robots" content="noindex,nofollow"> while the component
 * is mounted, then removes it on unmount so it never affects other routes.
 */
export default function useNoIndex() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    meta.dataset.owner = "noindex-hook";
    document.head.appendChild(meta);
    return () => {
      if (meta.parentNode) meta.parentNode.removeChild(meta);
    };
  }, []);
}
